// libs
import React, { memo } from 'react';

//components
import Checkbox from '@nykaa/ui-components/Checkbox';

//styles
import { Wrapper, ValueContainer, OptionName, OptionCount } from './styles';

//defs
interface ShopAllCheckboxProps {
  onShopAllClick: VoidFunction;
  allProductCount: number;
  isChecked: boolean;
}

const SHOP_ALL_TEXT = 'Shop All';

function ShopAllCheckbox({ onShopAllClick, allProductCount, isChecked }: ShopAllCheckboxProps) {
  const EMPTY_FUNC = () => {};

  return (
    <Wrapper onClick={onShopAllClick} isSelected={isChecked}>
      <ValueContainer>
        <OptionName>{SHOP_ALL_TEXT}</OptionName>
        <OptionCount>{allProductCount}</OptionCount>
      </ValueContainer>
      <Checkbox checked={isChecked} onClick={EMPTY_FUNC} onChange={EMPTY_FUNC} />
    </Wrapper>
  );
}

export default memo(ShopAllCheckbox);
